import {mix} from 'polished';
import {DefaultTheme} from 'styled-components';

import {black, white, gull, intKlein} from '../colors';

export const Theme: DefaultTheme = {
    color: {
        primary: gull,
        secondary: black,
        foreground: gull,
        background: black,
        breadcrumb: mix(0.265, gull, intKlein),
        label: mix(0.4, white, white)
    },
    breakpoint: {
        tablet: '576px',
        desktop: '1144px'
    }
};

// TODO: Dark theme variant
export const DarkTheme: DefaultTheme = Theme;

// TODO: alternative theme converter
export const AlternativeTheme = (currentTheme: DefaultTheme): DefaultTheme => {
    return currentTheme;
};
